<template>
  <div id="app">
    <Navbar />
    <div v-on:click="closeNavbar">
      <Alert />
      <router-view />
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Alert from "@/components/Alert.vue";
import Footer from "@/components/Footer.vue";
import { mapActions } from "vuex";

export default {
  name: "app",
  methods: {
    ...mapActions("navbar", ["closeNavbar"]),
    ...mapActions("pages", ["findActivePage"])
  },
  updated() {
    this.findActivePage(this.$route);
  },
  watch: {
    $route() {
      this.findActivePage(this.$route);
    }
  },
  components: {
    Navbar,
    Alert,
    Footer
  }
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
